/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd
 */
export interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd {
    /**
     * 
     * @type {Array<string>}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd
     */
    valueList?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd
     */
    isVisable?: string;
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePdFromJSON(json: any): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd {
    return JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePdFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePdFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'valueList': !exists(json, 'valueList') ? undefined : json['valueList'],
        'isVisable': !exists(json, 'isVisable') ? undefined : json['isVisable'],
    };
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePdToJSON(value?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'valueList': value.valueList,
        'isVisable': value.isVisable,
    };
}

